<template>
  <div class="flex-page">
    <div class="flex-1 padding-lr-12 order-completion">
      <div class="card" style="padding: 12px 0" v-if="getOrderDeliveryStatus === null">
        <van-skeleton :row="2" />
      </div>
      <div class="card flex align-center" v-else-if="getOrderDeliveryStatus === 2">
        <van-field
          class="selfMention-field"
          v-model="linkMan"
          label="联系人"
          placeholder="请输入姓名"
          maxlength="10"
          direction="column"
        />
        <div class="hr-split van-hairline--left" />
        <van-field
          class="selfMention-field"
          type="tel"
          v-model.trim="phoneNum"
          label="预留手机"
          placeholder="请输入手机号"
          maxlength="11"
          direction="column"
          @blur="mobileValidator(phoneNum)"
        />
      </div>
      <div class="card bg-white split" v-else-if="getOrderDeliveryStatus === 0 || getOrderDeliveryStatus === 1">
        <components-address
          :receiverInfo="receiverInfo"
          :showNotice="getOrderDeliveryStatus === 0"
        ></components-address>
      </div>

      <div class="card" style="padding: 12px 0" v-if="!hasOrderList">
        <van-skeleton title :row="3" />
      </div>

      <div class="card" v-for="(order, index) in preOrderData.preOrderList || {}" :key="index">
        <store-card
          :store="order.storeInfo || {}"
          :supplierId="order.supplierId"
          :isPickOrder="order.deliveryWay === 2"
          :isSplitOrder="isSplitOrder"
          :distanceMap="distanceMap"
        >
          <div class="card-goods-container">
            <template v-if="preOrderData.orderClassifyType != '1'">
              <goods-item style="padding: 0" v-if="order.itemList.length === 1" :goods="order.itemList[0]"></goods-item>
              <goods-list v-else :goodsList="order.itemList" :isShowGoodList="true"></goods-list>
            </template>
            <template v-else>
              <zy-goods-list :goodsList="order.itemList" :isShowGoodList="true" :isShowBuyCount="order.isShowBuyCount" :doseCount="order.traditionalMedicineDoseCount"></zy-goods-list>
            </template>
          </div>
          <div class="flex-between card-way-container">
            <span>{{ order.deliveryWay === 1 ? '配送方式' : '自提时间' }}</span>
            <div class="deliveryWay">
              <span v-if="order.deliveryWay === 1">快递配送</span>
              <span v-else @click="selectSelfMentionTime(order, index)">
                {{ order.timeSection | paresPickTime(order) }}
                <van-icon name="cap-arrow" color="#bfbfbf" />
              </span>
            </div>
          </div>
          <div class="card-price-container van-hairline--top">
            <template v-if="preOrderData.orderClassifyType != '1'">
              共{{ order.itemList && order.itemList.length }}件
            </template>
            <template v-else>
              共{{ order.traditionalMedicineDoseCount }}剂
            </template>
            ，小计 ¥
            <span class="itemPrice">{{ (order.itemPrice + order.consultationFee || 0) | price }}</span>
          </div>
        </store-card>
      </div>

      <div class="card" style="padding: 8px 0" v-if="getOrderDeliveryStatus !== null">
        <div class="card-price-cell">
          <span class="title">商品金额</span>
          <p>
            <span class="symbol">¥</span>
            {{ (totalAmount + consultationFee) | price }}
          </p>
        </div>

        <div class="card-price-cell">
          <span class="title">优惠券</span>
          <div @click.stop="chooseCoupon">
            <span v-if="!hasMoreCoupons && customizeCouponData && !customizeCouponData.couponUserId" class="no-coupon">
              暂无可用优惠券
            </span>
            <div v-else class="coupon-info">
              <span v-if="customizeCouponData && customizeCouponData.couponUserId" class="coupon-info-amount">
                -¥{{ customizeCouponData.discountsAmount | price }}
              </span>
              <span v-else style="color: #bfbfbf">选择优惠券</span>
              <van-icon name="cap-arrow" color="#BFBFBF" />
            </div>
          </div>
        </div>

        <div class="card-price-cell" v-if="getOrderDeliveryStatus === 0 || getOrderDeliveryStatus === 1">
          <span class="title">
            综合服务费
            <van-popover v-model="showPopover" theme="dark" :offset="[-8, 8]" placement="top-start">
              <div style="width: 200px; padding: 8px 12px; line-height: 20px; font-size: 12px">
                平台综合服务费是指为用户提供配送、打包、开票等服务产生的费用，按单收取。如有疑问，请您联系智云医道客服咨询。
              </div>
              <template #reference>
                <van-icon name="cap-toastwarning" class="icon" @click="showPopover = true" />
              </template>
            </van-popover>
          </span>
          <p>
            <span class="symbol">¥</span>
            {{ expressAmount | price }}
          </p>
        </div>
        <template v-if="preOrderData.isInsteadFrying == 1">
          <van-cell class="invoice-cell" title="代煎服务" :border="false">
            <van-switch :active-value="1" :inactive-value="0" v-model="insteadFryingSelected"></van-switch>
          </van-cell>
          <div class="card-price-cell" v-show="insteadFryingSelected == 1">
            <span class="title">代煎服务费</span>
            <p>
              <span class="symbol">¥</span>
              {{ preOrderData.insteadFryingFee | price }}
            </p>
          </div>
        </template>
        <template v-else-if="preOrderData.isInsteadFrying == 0">
          <div class="card-price-cell">
            <span class="title">代煎服务</span>
            <span style="color: #bfbfbf">
              暂不支持
            </span>
          </div>
        </template>
        <template v-else-if="preOrderData.isInsteadFrying == 3">
          <div class="card-price-cell">
            <span class="title">代煎服务</span>
            <span style="color: #bfbfbf">
              请先选择收货地址
            </span>
          </div>
        </template>
      </div>

      <div style="padding: 8px 0" class="card split">
        <van-cell class="invoice-cell" title="开具发票" :border="false">
          <van-switch v-model="drawInvoice"></van-switch>
        </van-cell>
        <div
          style="padding: 8px 0; margin: 8px 12px"
          v-show="drawInvoice"
          class="van-hairline--top van-hairline--bottom"
        >
          <draw-invoice ref="drawInvoice" :drawInvoice="drawInvoice" @inputInvoice="getInvoiceInput"></draw-invoice>
        </div>
        <van-field
          class="remark-field"
          autosize
          label="备注"
          v-model="remark"
          rows="1"
          :maxlength="100"
          placeholder="可输入备注要求"
          clearable
        />
      </div>
    </div>
    <footer class="footer van-hairline--top">
      <div class="footer-tips" v-if="isDrug">
        <p>根据国家法规要求：药品属特殊商品，除药品质量原因外，药品一经售出不得退换</p>
      </div>
      <section class="footer-btns flex align-center">
        <div class="footer-btns-block van-ellipsi">
          <div>
            <span class="block-statistics">合计:</span>
            <span style="margin-left: 5px">¥</span>
            <span class="block-price">
              {{ totalPrice | price }}
            </span>
          </div>
          <div style="color: #ff4e47; margin-top: 4px" v-if="customizeCouponData.discountsAmount && hasOrderList">
            已优惠¥{{ customizeCouponData.discountsAmount | price }}
          </div>
        </div>
        <van-button
          style="margin-left: 0"
          class="footer-btns-btn"
          v-reClick="() => submitOrder('thirdPay')"
          round
          plain
          type="primary"
          :disabled="!hasOrderList"
        >
          他人代付
        </van-button>
        <van-button class="footer-btns-btn" v-reClick="submitOrder" round type="primary" :disabled="!hasOrderList">
          立即支付
        </van-button>
      </section>
    </footer>

    <van-modal-sheet
      v-model="showModal"
      title="选择自提时间"
      right-text="取消"
      right-text-color="#8C8C8C"
      @titleRightClick="handleClosePickTime"
      :close-on-click-overlay="false"
    >
      <van-tree-select
        class="timeSection-tree van-hairline--top"
        :items="items"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndex"
        @click-item="handleTimeSectionClick"
      >
        <template v-slot:item="slotProps">
          <div>{{ slotProps.text }}</div>
        </template>
      </van-tree-select>
    </van-modal-sheet>
  </div>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import { TreeSelect, Dialog } from '@zyf2e/capui-mobile';

import ZYPay from '@zyf2e/checkout-sdk';
import mobileValidator from '@/mixins/mobileValidator';
import jumpCenter from '@/mixins/jumpCenter';

Vue.use(TreeSelect);

import DrawInvoice from '@/components/DrawInvoice.vue';
import Address from '@/components/AddressInfo.vue';
import { mapState } from 'vuex';

import GoodsList from '@/components/goodsList.vue';
import GoodsItem from '@/components/goodsItem.vue';
import storeCard from './components/StoreCard.vue';

import wechat from '@/util/wechatHelper.js';

import zyGoodsList from '@/components/zyGoodsList.vue';


export default {
  name: 'PlaceOrder',
  mixins: [mobileValidator, jumpCenter],
  components: {
    ComponentsAddress: Address,
    DrawInvoice,
    GoodsList,
    storeCard,
    GoodsItem,
    // countTo
    zyGoodsList
  },
  filters: {
    intPrice(val) {
      if (!val) return val;
      return Number(val) / 100;
    },
    paresPickTime(val) {
      if (!val) return '请选择自提时间';
      return val;
    }
  },

  beforeRouteEnter(to, { name }, next) {
    next(async (vm) => {
      const { orders = [] } = vm.preOrderParams;

      if ((!orders || orders.length <= 0) && to.query.action !== 'pre') {
        vm.$router.go(-1);
        return;
      }

      if (
        (name === 'AddressList' || name === 'chooseCoupon') &&
        vm.preOrderData &&
        vm.preOrderData?.preOrderList.length > 0
      ) {
        return;
      }

      vm.rxId = to.query.rxId || '';

      vm.initData();
      await vm.fetchAddress();
      vm.fetchData(true);
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$refs.drawInvoice.chooseInvoiceType = false;
    this.$refs.drawInvoice.chooseInvoiceKind = false;
    next();
  },

  async created() {
    this.items = [
      {
        text: `${this.returnCnLocaleMoment().format('[今天 ]ddd')}`,
        value: this.returnCnLocaleMoment().format('MM[月]DD[日]'),
        children: []
      },
      {
        text: `${this.returnCnLocaleMoment().add(1, 'days').format('[明天 ]ddd')}`,
        value: this.returnCnLocaleMoment().add(1, 'days').format('MM[月]DD[日]'),
        children: []
      },
      {
        text: `${this.returnCnLocaleMoment().add(2, 'days').format('[后天 ]ddd')}`,
        value: this.returnCnLocaleMoment().add(2, 'days').format('MM[月]DD[日]'),
        children: []
      }
    ];
  },
  async mounted() {
    await ZYPay.init({
      ...util.ZYpayConfig
    });
  },
  destroyed() {
    this.$store.commit('order/setCouponInfo', {});
  },
  data() {
    return {
      showPopover: false,

      rxId: '',

      remark: null,

      addLocation: '',

      useCoin: false,

      drawInvoice: false,

      walletPay: true,

      isDrug: true,

      receiverInfo: {
        address: '',
        name: '',
        mobile: '',
        addrId: undefined
      },

      invoiceInput: {},

      // fetched: false,

      preOrderData: {
        preOrderList: []
      },
      submitOrderParams: {},

      latitude: null,
      longitude: null,

      showModal: false,
      isThirdPay: false,
      items: [],
      activeId: '',
      activeIndex: 0,
      pickOrderIndex: {},
      linkMan: '',
      phoneNum: '',

      defaultTimeSection: [{ startTime: '9:00', endTime: '18:00' }],
      distanceMap: {},

      customizeBizId: '',
      customizeBizType: '',
      customizeCouponData: {
        couponId: null,
        couponUserId: null,
        discountsAmount: 0
      },
      payLock: false,
      insteadFryingSelected: 0
    };
  },
  computed: {
    ...mapState('order', [
      'preOrderParams', // 预下单参数
      'payInfo', // 支付信息 ？？ 废弃
      'supplyId', // 供应商id ？？ 废弃
      'couponInfo', // 优惠券信息
      'couponOptimalItemRequests', // 请求优惠券优惠金额信息
      'hasMoreCoupons' // 是否还有更多优惠券
    ]),
    ...mapState('address', ['addressInfo', 'location']),
    hasOrderList() {
      return this.preOrderData && this.preOrderData.preOrderList && this.preOrderData.preOrderList.length > 0;
    },
    isSplitOrder() {
      return this.preOrderData && this.preOrderData.preOrderList && this.preOrderData.preOrderList.length > 1;
    },
    expressAmount() {
      // if (this.preOrderData && Array.isArray(this.preOrderData.preOrderList)) {
      //   return this.preOrderData.preOrderList.reduce((acc, cur) => {
      //     let express = cur.deliveryWay === 1 && cur.expressFee ? cur.expressFee : 0;
      //     return acc + express;
      //   }, 0);
      // }
      if (this.preOrderData) {
        return this.preOrderData.expressFee || 0;
      }
      return 0;
    },
    totalAmount() {
      if (this.preOrderData && Array.isArray(this.preOrderData.preOrderList)) {
        return this.preOrderData.preOrderList.reduce((acc, cur) => acc + cur.itemPrice, 0);
      }
      return 0;
    },
    getOrderDeliveryStatus() {
      // 0: 混合， 1: 快递， 2: 自提
      let status = null;
      if (this.preOrderData && Array.isArray(this.preOrderData.preOrderList)) {
        status = this.preOrderData.preOrderList[0]?.deliveryWay || null;
        for (let ele of this.preOrderData.preOrderList) {
          status = status & ele.deliveryWay;
          if (status === 0) return status;
        }
      }
      return status;
    },
    totalPrice() {
      return this.totalAmount + this.expressAmount - (this.customizeCouponData.discountsAmount || this.couponInfo.discountsAmount || 0) + (this.insteadFryingSelected ? (this.preOrderData.insteadFryingFee || 0) : 0) + this.consultationFee;
    },
    consultationFee() {
      return this.preOrderData?.consultationFee || 0;
    }
  },
  watch: {
    addressInfo: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal = {}) {
        if (this.$route.name === 'PlaceOrder') {
          return;
        }
        const { province, city, region, address, name, mobile, addrId } = newVal || {};
        this.receiverInfo = {
          address: province + city + region + address,
          name,
          mobile,
          addrId
        };
        this.addLocation = city;
        this.submitOrderParams.addressId = addrId;
        if (newVal.addrId !== oldVal.addrId || province !== oldVal.province || city !== oldVal.city) {
          this.fetchData(false, 'updateCoupon');
        }
      }
    },
    couponInfo: {
      deep: true,
      immediate: true,
      handler: function (newVal, oldVal = {}) {
        if (this.$route.name === 'PlaceOrder') {
          return;
        }

        if (!newVal) this.customizeCouponData = {};

        this.customizeCouponData = {
          couponId: newVal.couponId || null,
          couponUserId: newVal.couponUserId || null,
          discountsAmount: newVal.discountsAmount || 0
        };
      }
    }
  },
  methods: {
    async fetchData(firstTime = false, updateCoupon) {
      const { addrId } = this.addressInfo;
      const hasSupplyId = this.supplyId
        ? {
            supplierId: this.supplyId
          }
        : null;
      let params = {
        ...this.preOrderParams,
        location: this.addLocation || this.location,
        addressId: addrId,
        ...hasSupplyId
      };

      // store数据暂存放至data
      this.customizeBizId = this.preOrderParams?.bizId || null;
      this.customizeBizType = this.preOrderParams?.bizType || null;

      try {
        const preOrderData = this.$route.params.preOrderData && JSON.parse(this.$route.params.preOrderData);
        if (firstTime && preOrderData) {
          this.preOrderData = preOrderData;
        } else {
          params.channel = this.$route.query.channel;
          params.rxId = this.$route.query.rxId || '';

          this.preOrderData = await this.$fetch.postPreOrder(params);
          if (this.preOrderData.code === 1001) {
            this.$dialog
              .alert({
                title: '商品信息确认',
                message: this.preOrderData.errorMsg || ''
              })
              .then(() => {
                // on close
              });
          }

          if (this.preOrderData.code === 200 && this.preOrderData.orderId) {
            this.$toast('已经生成订单');
            console.log('data: ', this.preOrderData);
            this.jumpToMallOrderDetail(this.preOrderData.orderId, 0);
            return;
          } else {
            console.log('data: ', this.preOrderData);
          }
        }
      } catch (error) {
        const message = error && error.code && error.message ? error.message : '下单异常，请您稍后再试';
        this.$dialog.confirm({ message, showCancelButton: false }).then(() => {
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        });
      }

      // 获取最优优惠券，因为价格以预下单返回为准，在预下单接口结束后，获取优惠券

      let couponOptimalItemRequests = [];
      this.preOrderData?.preOrderList.forEach((ele) => {
        const items = ele.itemList.map((item) => {
          return {
            itemId: item.itemId,
            itemNum: item.itemNum * (ele.traditionalMedicineDoseCount || 1),
            price: item.realPrice,
            supplierId: ele.supplierId,
            deliveryWay: ele.deliveryWay,
            goodsId: item.goodsId
          };
        });
        couponOptimalItemRequests = couponOptimalItemRequests.concat(items);
      });

      this.$store.commit('order/setCouponOptimalItemRequests', couponOptimalItemRequests);
      const { bizType = '', bizId = '' } = this.preOrderParams;
      this.$fetch
        .confirmUseCoupon({
          couponOptimalItemRequests,
          bizType,
          bizId
        })
        .then((res = {}) => {
          this.userId = res.userId;
          // 表示自动领券
          if (res.code === 1) {
            this.$toast('已为您领取1张优惠券，下单更优惠');
          }
          // 没有优惠券用最优的
          if ((!this.couponInfo?.couponUserId && !this.hasMoreCoupons) || updateCoupon) {
            // 当之前没有优惠券，刷新页面又取到了新优惠券 就会，将新的优惠券默认使用
            this.$store.commit('order/setCouponInfo', res);
            this.customizeCouponData = {
              couponId: res.couponId || null,
              couponUserId: res.couponUserId || null,
              discountsAmount: res.discountsAmount || 0
            };
          } else {
            // 否则使用store里的优惠券
            this.customizeCouponData = {
              ...this.couponInfo
            };
          }

          if (res.couponUserId) {
            this.$store.commit('order/setHasMoreCoupons', true);

            // this.hasMoreCoupons = true;
            // this.$store.commit('order/setPreOrderParams', { ...this.preOrderParams, hasMoreCoupons: true });
          }
        })
        .catch((res) => {
          this.$store.commit('order/setCouponInfo', {});
        });

      try {
        if (this.getOrderDeliveryStatus === 0 || this.getOrderDeliveryStatus === 2) {
          const { latitude, longitude } = await wechat.getLocation();

          // const { latitude, longitude } = await window.wx.getLocation();
          const supplerIds = this.preOrderData.preOrderList.map((val) => val.supplierId);
          const distances = await this.$fetch.queryStoreDistance({
            latitude,
            longitude,
            supplerIds
          });
          this.distanceMap = distances.reduce((pre, cur) => {
            pre[cur.supplierId] = cur;
            return pre;
          }, {});
        }
      } catch (e) {
        console.log("can't get wx Location", e);
      }
    },

    async initData() {
      // this.fetched = false;
      this.remark = null;
      this.addLocation = '';
      this.useCoin = false;
      this.drawInvoice = false;
      this.receiverInfo = {
        address: '',
        name: '',
        mobile: '',
        addrId: undefined
      };
      this.invoiceInput = {};
      this.preOrderData = {};

      // eslint-disable-next-line
      Telescope.trackPage({ trackId: 'zyyd-page-FillOrder' });

      if (this.$route.query.isDrug === '0' || this.$route.query.isDrug === 0) {
        this.isDrug = false;
      }
    },

    async fetchAddress() {
      const res = await this.$fetch.getDefaultAddress();
      this.$store.commit('address/setAddressInfo', res);

      const { addrId, address, city, mobile, name, province, region } = this.addressInfo;
      this.receiverInfo = {
        address: province + city + region + address,
        name,
        mobile,
        addrId
      };

      this.addLocation = city;
      this.submitOrderParams.addressId = addrId;
    },
    async submitOrder(type) {
      this.isThirdPay = type === 'thirdPay';
      if (
        (this.getOrderDeliveryStatus === 1 || this.getOrderDeliveryStatus === 0) &&
        !this.submitOrderParams.addressId
      ) {
        this.$toast('收货地址不能为空');
        return;
      }

      if (this.getOrderDeliveryStatus === 2 && (!this.linkMan || !this.phoneNum)) {
        if (!this.linkMan) {
          this.$toast('请填写联系人');
          return;
        }

        if (!this.phoneNum) {
          this.$toast('请填写预留手机');
          return;
        }
      }
      if (this.getOrderDeliveryStatus === 2 && !this.mobileValidator(this.phoneNum)) {
        this.$toast('手机号格式错误');
        return;
      }

      const { preOrderList = [] } = this.preOrderData;

      const result = preOrderList.some((item) => {
        return item.deliveryWay === 2 && !item.timeSection;
      });
      if (result) {
        this.$toast('请选择自提时间');
        return;
      }

      // 检查发票必填项
      if (this.drawInvoice && !this.$refs.drawInvoice.validate()) {
        return;
      }

      // const haveOfflineItems = preOrderList.some((order) => order.payWay > 1);

      // if (haveOfflineItems && this.totalAmount > 0) {
      //   const { canUseNum = 0, onlineCanUseNum = 0 } = (this.useCoin && this.preOrderData.coin) || {};
      //   const { offlinePrice = 0 } = this.preOrderData || {};
      //   const offPay = offlinePrice - canUseNum + onlineCanUseNum;
      //   const onlinePay = `在线支付${((this.totalAmount - offPay) / 100).toFixed(2)}元，`;
      //   await this.$dialog.confirm({
      //     title: '温馨提示',
      //     message: `您的订单含${offPay === this.totalAmount ? '' : onlinePay}货到付款${(offPay / 100).toFixed(
      //       2
      //     )}元，您在收货时${offPay === this.totalAmount ? '' : '仍'}需支付${(offPay / 100).toFixed(
      //       2
      //     )}元。我们会在您成功下单后48小时内发货，是否确认购买？`
      //   });
      //   await this.handleSubmit();
      //   return;
      // }
      this.presubmit();
    },

    async presubmit() {
      const { addressId } = this.submitOrderParams;

      const params = { addressId };
      try {
        const { expressLimit, content } = await this.$fetch.submitMedicasalePreOrder(params);
        if (expressLimit) {
          this.$dialog
            .confirm({
              title: '风险提示',
              message: content,
              confirmButtonText: '继续支付'
            })
            .then(async () => {
              await this.handleSubmit();
            })
            .catch(() => {
              // on cancel
            });
          return;
        }
        await this.handleSubmit();
      } catch (err) {
        console.log(err);
        await this.handleSubmit();
      }
      return;
    },

    async handleSubmit() {
      if (this.payLock) {
        this.$toast('支付中，请勿重复点击');
        return;
      }
      this.payLock = true;
      // 提交订单

      const { preOrderData } = this;

      const { signContent, preOrderList = [] } = preOrderData;

      const { doctorId } = this.$route.query;

      const { bizType = '', bizId = '' } = this.preOrderParams;

      // 没有开启开具发票
      if (!this.drawInvoice) {
        this.invoiceInput = {};
      }

      const orders = preOrderList.map((item) => {
        const { deliveryWay = '', supplierId = '', timeSection = '' } = item;
        return {
          deliveryWay,
          supplierId,
          timeSection,
          itemList: item.itemList.map((ele) => {
            return {
              itemId: ele.itemId, // 商品skuID
              itemNum: ele.itemNum * (item.traditionalMedicineDoseCount || 1),
              goodsId: ele.goodsId, // 供应商商品ID
              supplierId: item.supplierId
            };
          })
        };
      });

      const params = {
        orders, // 商品
        channel: 'MEDIC_SALE',
        signContent, // 支付参数
        totalPrice: this.totalPrice, // 总价格
        bizType: bizType || this.customizeBizType, // 业务类型，可为空
        bizId: bizId || this.customizeBizId, // 业务Id
        doctorId, // 医生id
        remark: this.remark || null, // 备注
        linkMan: this.linkMan || this.receiverInfo.name || null, // 自提联系人
        phoneNum: this.phoneNum || this.receiverInfo.mobile || null, // 自提联系方式
        ...this.submitOrderParams, // 地址信息
        invoiceInfo: this.drawInvoice
          ? {
              ...this.invoiceInput // 发票信息
            }
          : null,
        couponUserId: this.customizeCouponData.couponUserId || this.couponInfo.discountsAmount || null,
      };

      if (preOrderData.isInsteadFrying == 1) {
        params.insteadFryingSelected = this.insteadFryingSelected;
        params.insteadFryingFee = preOrderData.insteadFryingFee;
      }

      try {
        const res = await this.$fetch.commitOrder(params);
        this.$store.commit('order/setPayInfo', res);
        const { orderId, payOnline } = this.payInfo;
        const prescription = this.preOrderParams.rxType ? '1' : '2';

        if (this.isThirdPay) {
          this.$router.push({
            name: 'thirdPay',
            query: {
              orderId
            }
          });
          this.clearStore();
          this.payLock = false;
          return;
        }

        // eslint-disable-next-line
        Telescope.trackEvent({ trackId: 'zyyd-click-FillOrder-SubmitOrder', custom: { orderId: orderId || '' } });

        if (!payOnline) {
          this.$router.replace({
            name: 'PaymentSuccess',
            query: { orderId, prescription }
          });
          this.clearStore();
          this.payLock = false;
          return;
        }

        if (!orderId) {
          this.$toast('订单ID获取失败');
          this.payLock = false;
          return;
        }

        try {
          const { tradeNo = '' } = await this.$fetch.fetchGetTradeNo({ orderId });

          const backParams = { orderId, prescription, userType: this.userType };

          this.$toast.loading({ duration: 3000, forbidClick: true });

          const payParams = {
            failUrl: encodeURIComponent(`${window.location.origin}#/payment/fail${util.parseParam(backParams)}`),
            successUrl: encodeURIComponent(`${window.location.origin}#/payment/success${util.parseParam(backParams)}`)
          };
          await ZYPay.prePay({ tradeNo, ...payParams });
          this.payLock = false;
          window.history.replaceState(null, '', `#/order-detail/${orderId}`);
        } catch (error) {
          this.payLock = false;
          if (error === 'INIT_ADAPT_ERROR') {
            Dialog.confirm({
              title: '温馨提示',
              message: '支付环境异常,请刷新重试',
              confirmButtonText: '立即重试'
            })
              .then(() => {
                window.location.reload();
                // on confirm
              })
              .catch((action) => {
                // on cancel or assist
              });
            return;
          }
          // 已唤起微信支付，无法再次生成tradeNo，需要跳转订单详情页面
          if (
            error?.message === '支付失败' ||
            error?.message === '支付取消' ||
            error === 'pay_cancel' ||
            error === 'pay_fail'
          ) {
            this.$router.replace(`/order-detail/${orderId}`);
          } else {
            this.$toast(error && error.message ? error.message : error);
          }
        }
        // utils.payHandle.call(this, {
        //   tradeNo,
        //   backParams,
        //   channel: 'MEDIC_SALE'
        // });

        // window.history.replaceState(null, '', `#order-detail/${orderId}?channel=${this.$route.query.channel}`);

        this.clearStore();
      } catch (error) {
        this.payLock = false;
        if (error.code === '-5000') {
          const { bizType = '', bizId = '' } = this.preOrderParams;
          this.$fetch
            .confirmUseCoupon({
              couponOptimalItemRequests: this.couponOptimalItemRequests,
              bizType,
              bizId
            })
            .then((res = {}) => {
              // 表示自动领券
              if (res.code === 1) {
                this.$toast('已为您领取1张优惠券，下单更优惠');
              }
              this.$store.commit('order/setCouponInfo', res);

              this.customizeCouponData = {
                couponId: res.couponId || null,
                couponUserId: res.couponUserId || null,
                discountsAmount: res.discountsAmount || 0
              };
              if (res.couponUserId) {
                this.$store.commit('order/setHasMoreCoupons', true);

                // this.hasMoreCoupons = true;
                // this.$store.commit('order/setPreOrderParams', { ...this.preOrderParams, hasMoreCoupons: true });
              }
            })
            .catch((res) => {
              this.$store.commit('order/setCouponInfo', {});
            });
        }
        this.$toast(error.message);
      }
    },
    selectSelfMentionTime(order, index) {
      this.activeId = order.timeSection || '';
      this.activeIndex = order.pickDayIndex || '';
      this.pickOrderIndex = index;

      // 前端缓存的可选时间
      if (order.items) {
        this.items = order.items;
        this.showModal = true;
        return;
      }

      // 有些供应商咩有配置信息，需要使用默认时间
      /**
       * timeSection: [
       *   {startTime: '', endTime: ''}
       * ]
       */
      let timeSection = this.defaultTimeSection;
      if (order.storeInfo.openTimeSection && order.storeInfo.openTimeSection.length > 0) {
        timeSection = order.storeInfo.openTimeSection;
      }
      const timeArr = this.returnIntervalDividedByOneHour(timeSection);

      // 往今天、明天、后天选项里插值
      this.items = this.items.map((item, index) => {
        let arrTamp = JSON.parse(JSON.stringify(timeArr));

        // 如果是【今天】，需要过滤掉不能选的
        if (index === 0) {
          arrTamp = arrTamp.filter((i) => !i.hidden);
        }
        arrTamp = arrTamp.map((ele) => {
          ele.id = `${item.value} ${ele.text}`;
          return ele;
        });
        item.children = arrTamp;
        return item;
      });

      // if today has no options，delete it
      this.items = this.items.filter((item) => item.children.length > 0);

      order.items = JSON.parse(JSON.stringify(this.items));

      this.showModal = true;
    },
    handleClosePickTime() {
      this.showModal = false;
      this.activeId = '';
      this.activeIndex = 0;
    },

    handleTimeSectionClick() {
      if (this.activeId) {
        let order = this.preOrderData.preOrderList[this.pickOrderIndex];
        order.timeSection = this.activeId;
        order.pickDayIndex = this.activeIndex;
        this.$set(this.preOrderData.preOrderList, this.pickOrderIndex, order);
      }
      this.showModal = false;

      this.activeId = '';
      this.activeIndex = 0;
    },

    clearStore() {
      this.$store.commit('order/setPreOrderParams', {});
      this.$store.commit('order/setPayInfo', {});
      // 清除优惠券本地存储
      this.$store.commit('order/setCouponInfo', {});
      this.$store.commit('order/setHasMoreCoupons', false);
    },

    getInvoiceInput(val) {
      this.invoiceInput = val;
    },

    onBack() {
      this.clearStore();
      this.$router.go(-1);
      // this.adapter.goBack();
    },

    returnMomentByHHmm(time = '') {
      var hour = time.split(':')[0];
      var min = time.split(':')[1];

      return moment().hour(hour).minute(min).second(0).valueOf();
    },
    returnCnLocaleMoment() {
      return moment().locale('zh-cn');
    },
    returnIntervalDividedByOneHour(timeSection) {
      // 当前时间之前的时间不可选择
      const nowTimeStamp = Date.now();
      let timeArr = [];
      timeSection.forEach((item) => {
        // 目前需求 用户选择自提区间为一小时,供应商可门店设置时间最短间隔为半小时
        const startTimeStamp = this.returnMomentByHHmm(item.startTime);
        const endTimeStamp = this.returnMomentByHHmm(item.endTime);

        // 该次循环内都不能选
        const isAllHidden = nowTimeStamp >= endTimeStamp;

        if (endTimeStamp - startTimeStamp <= 3600000) {
          // 当前时间是否在选项的区间内，若是则设置hidden属性为true
          const hidden = isAllHidden || (nowTimeStamp > startTimeStamp && nowTimeStamp < endTimeStamp);

          // 若开始、结束区间小于等于1小时，直接push
          timeArr.push({ text: `${item.startTime}-${item.endTime}`, hidden });
        } else {
          // 计算当前区间可以分为几个一小时，并向上取整
          const intervalTimes = Math.ceil(((endTimeStamp - startTimeStamp) / 3600000).toFixed(1));
          let interValTimeEnd = startTimeStamp;
          for (let i = 1; i <= intervalTimes; i++) {
            // 当前时间是否在选项的区间内，或者超出区间结尾时间，若是则设置hidden属性为true
            let hidden = false;
            if (
              isAllHidden ||
              nowTimeStamp > 3600000 + interValTimeEnd ||
              (nowTimeStamp > interValTimeEnd && nowTimeStamp < 3600000 + interValTimeEnd)
            ) {
              hidden = true;
            }

            if (i === intervalTimes) {
              // last loop
              timeArr.push({
                text: `${moment(interValTimeEnd).format('HH:mm')}-${item.endTime}`,
                hidden
              });
            } else {
              timeArr.push({
                text: `${moment(interValTimeEnd).format('HH:mm')}-${moment(3600000 + interValTimeEnd).format('HH:mm')}`,
                hidden
              });
            }

            interValTimeEnd += 3600000;
          }
        }
      });

      return timeArr;
    },
    chooseCoupon() {
      const { bizType = '', bizId = '' } = this.preOrderParams;
      const { addressId } = this.submitOrderParams;

      this.$router.push({
        name: 'chooseCoupon',
        query: {
          bizType,
          bizId,
          addressId
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.padding-lr-12 {
  padding: 0 12px;
}

.title {
  .icon {
    cursor: pointer;
  }
}
.remark-field {
  padding: 8px 12px;
  /deep/ .van-cell__flexrow {
    .van-cell__title {
      font-size: 14px;
      color: #262626;
      margin-right: 33px;
    }
    .van-cell__value {
      font-size: 14px;
      input {
        &::placeholder {
          font-size: 14px;
        }
        text-align: right;
      }
    }
  }
}
.flex-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  .flex-1 {
    flex: 1;
    overflow: auto;
  }
}
.order-completion {
  padding-top: 12px;
  .card {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    color: #262626;
    .flex-between {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 17px 0;
    }
    &-goods-container {
      padding: 12px 0;
    }
    &-way-container {
      font-size: 14px;
      .deliveryWay {
        span {
          font-size: 12px;
          color: #1e8dff;
        }
      }
    }

    &-price-container {
      padding: 16px 0;
      text-align: right;
      .itemPrice {
        font-size: 16px;
      }
    }

    &-price-cell {
      padding: 8px 12px;
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      color: #262626;
      font-size: 14px;
      span.symbol {
        font-size: 10px;
      }
      .coupon-info {
        &-amount {
          color: #ff4e47;
          // margin-right: 4px;
        }
      }
      .no-coupon {
        color: #bfbfbf;
      }
    }
    .hr-split {
      height: 32px;
      width: 1px;
    }
    .selfMention-field {
      /deep/ .van-cell__flexrow {
        .van-field__label {
          font-size: 12px;
        }
      }
    }

    .invoice-cell {
      padding: 8px 12px;
      /deep/ .van-cell__title {
        color: #262626;
        font-size: 14px;
        line-height: 20px;
      }
      /deep/ .van-cell__value {
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}
.footer {
  font-size: 12px;
  line-height: 16px;
  color: #262626;
  &-tips {
    padding: 8px 12px;
    background: #fff7e6;
    color: #ff8200;
  }
  &-btns {
    padding: 8px 12px;
    background: #fff;
    &-block {
      flex: 1;
      .block-price {
        // color: #ff4e47;
        font-size: 16px;
      }
    }
    &-btn {
      height: 40px;
      padding: 12px 20px;
      margin-left: 8px;
    }
  }
}
/deep/ .van-cell--clickable:active {
  background-color: #fff;
}

.timeSection-tree {
  height: 364px !important;
  /deep/ .van-tree-select__nav {
    width: 112px;
    background: #f5f5f5;
    .van-tree-select__nav-item {
      color: #262626;
      font-size: 14px;
      background: #f5f5f5;
      text-align: center;
      &.van-sidebar-item--select {
        &::before {
          display: none;
        }
        color: #1e8dff;
        background: #fff;
      }
    }
  }
  /deep/ .van-tree-select__content {
    .van-tree-select__item {
      color: #262626;
      font-weight: 400;
      padding-left: 24px;
      &.van-tree-select__item--active {
        color: #1e8dff;
        font-weight: 500;
      }
    }
  }
}
</style>
